import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { StoreManagementBrandService } from '@/services/StoreManagement/Brands/StoreManagementBrandService';

export type StoreManagementBrandSearchListParams = {
  limit: number;
  currentPage: number;
};

export type StoreManagementBrandSearchList = {
  id: number;
  name: string;
};

export type StoreManagementSearchListResponse = {
  count: number;
  brands: StoreManagementBrandSearchList[];
};

export const useStoreManagementBrandSearchList = async (
  params: StoreManagementBrandSearchListParams
): Promise<StoreManagementSearchListResponse> => {
  const storeManagementBrandService = new StoreManagementBrandService(
    getClient()
  );
  try {
    return await storeManagementBrandService.searchList(params);
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
